import {
  UsageAttentionCardId,
  UsageExplorerViewToken,
} from "../../types/analytics/UsageExplorerViewToken";

export function createExplorerViewToken(
  attentionCardId: UsageAttentionCardId,
): UsageExplorerViewToken {
  return {
    lens: "BY_MANAGER",
    attentionCardId,
    locationBreadcrumbIds: [],
    searchText: "",
    showDistribution: false,
  };
}
